import type { Element, RectangleElement } from '@/components/canvas/document/publicTypes';

/** 供页面选中复用 SelectionBoxLayer / HandleLayer 的占位元素（非文档内真实元素） */
export function createPagePseudoElement(width: number, height: number): RectangleElement {
  return {
    id: '__page__',
    type: 'rect',
    version: 1,
    meta: {},
    layout: { x: 0, y: 0, zIndex: 0, rotation: 0 },
    size: { width, height },
    appearance: { opacity: 1 },
    typography: { fontFamily: 'system-ui', fontSize: 16, fontWeight: 400, fontStyle: 'normal', color: '#000000' },
    paragraph: { textAlign: 'left' },
    interaction: { visible: true, locked: false },
    data: {},
  };
}

export function pageSelectionRect(width: number, height: number) {
  return { x: 0, y: 0, width, height };
}
